import * as R from 'ramda'

import {
  CommonIncidentId,
  EventStatusId,
  IncidentId,
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getCommonBlockedIncidents,
  PocketIncidents,
  PocketIncidentsConfig,
} from '../../configuration'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: SoccerIncidentId.PossibleVAR,
    title: 'Possible VAR',
  },
  {
    incidentId: SoccerIncidentId.VarEnded,
    title: 'VAR Ended',
  },
  {
    incidentId: SoccerIncidentId.AddedTime,
    title: 'Added time',
  },
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'Tech. problem',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: CommonIncidentId.MatchResumed,
    title: 'Match resumed',
  },
  {
    incidentId: SoccerIncidentId.WaterBreak,
    title: 'Water break',
  },
  {
    incidentId: SoccerIncidentId.RefereesInjury,
    title: "Referee's injury",
  },
  {
    incidentId: SoccerIncidentId.BreakDuringTheGame,
    title: 'Break during the game',
  },
]

const commonBlockedIncidents = getCommonBlockedIncidents(
  pocketIncidents,
  morePocketIncidents,
)

const blockedPocketIncidentsMap = new Map<EventStatusId, Set<IncidentId>>([
  [SoccerEventStatusId.Abandoned, commonBlockedIncidents],
  [SoccerEventStatusId.Cancelled, commonBlockedIncidents],
  [SoccerEventStatusId.NotStarted, commonBlockedIncidents],
  [SoccerEventStatusId.StartDelayed, commonBlockedIncidents],
  [SoccerEventStatusId.Postponed, commonBlockedIncidents],
  [SoccerEventStatusId.Halftime, commonBlockedIncidents],
  [SoccerEventStatusId.WaitingForExtratime, commonBlockedIncidents],
  [SoccerEventStatusId.ExtratimeHalftime, commonBlockedIncidents],
  [SoccerEventStatusId.WaitingForPenalty, commonBlockedIncidents],
  [SoccerEventStatusId.FinishedAfterExtratime, commonBlockedIncidents],
  [SoccerEventStatusId.FinishedAfterPenalties, commonBlockedIncidents],
  [SoccerEventStatusId.FinishedAwardedWin, commonBlockedIncidents],
  [SoccerEventStatusId.FinishedRegularTime, commonBlockedIncidents],
  [SoccerEventStatusId.Interrupted, commonBlockedIncidents],
  [SoccerEventStatusId.ToFinish, commonBlockedIncidents],
  [
    SoccerEventStatusId.PenaltyShootout,
    new Set(
      R.without(
        [SoccerIncidentId.PossibleVAR, SoccerIncidentId.VarEnded],
        [...commonBlockedIncidents],
      ),
    ),
  ],
])

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap,
}
